import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MuiAvatar from '@material-ui/core/Avatar';
import { PALETTE } from 'Theme';
import { makeStyles, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { capitalize, createCustomColoring } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/utils';

const MUI_COLORS = [
  'default',
];

export const COLORS = [
  ...MUI_COLORS,
  ...Object.keys(PALETTE.facet),
];

const styles = () => ({
  root: {},
  colorDefault: {},
  circle: {},
  rounded: {},
  square: {},
  img: {},
  fallback: {},
});

const useCustomStyles = makeStyles(theme => ({
  ...createCustomColoring(theme, 'root', PALETTE.facet, (_, color) => {
    return {
      backgroundColor: color,
    };
  }),
}));

const Avatar = ({
  className,
  classes,
  color,
  ...rest
}) => {
  const customClasses = useCustomStyles();
  const {
    root: rootClass,
    ...restClasses
  } = classes;

  return (
    <MuiAvatar
      classes={{
        ...restClasses,
        root: classNames(
          classes.root,
          className,
          customClasses[`root${capitalize(color)}`],
        ),
      }}
      {...rest}
    />
  );
};

Avatar.defaultProps = {
  className: '',
  color: 'default',
};

Avatar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(COLORS),
};

export default withStyles(styles)(Avatar);
